import { useLocation } from "react-router-dom";
import CustomTitle from "../../../../components/CustomMiscellaneous/CustomTitle";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../../../services/api.service";
import TableView from "../../../Common/TableView";
import { AcabamentosConfig } from "./Acabamentos.config";

export default function Acabamentos() {


    const location = useLocation();
    const currentRoute = location.pathname;
    const obraId = currentRoute.split("/")[2];
    const pecaId = currentRoute.split("/")[4];

    const EXTENSION = `/obras/${obraId}/pecas/${pecaId}/operacoes/Acabamento`;

    return(<>{EXTENSION?<div>
        <CustomTitle small text={'Operações de Acabamento'}/>
        <TableView 
        title={"Operações de Acabamento"}
        postEntity={genericPost(EXTENSION)}
        editEntity={genericUpdate(EXTENSION)}
        deleteEntity={genericDelete(EXTENSION)}
        addButtonText={"Nova Operação"} 
        searchButtonText={"Procurar Operação"}
        tableConfigs={AcabamentosConfig}
        dataBuildFunction={generalObjectBuilder(AcabamentosConfig)}
        entityName={"Operações Acabamento"}
        idProp={"id"}
        configMapKey={`obras/${obraId}/pecas/${pecaId}/operacoes/Acabamento`}
        hidePagination
        hideFilters
        reroute={true}
        isSubTable
          />
    </div>:null}</>)

}